import { GenerateResource } from '.'
import { ShiftEnum } from '../enums/ShiftEnum'
export const ShiftResource: GenerateResource<string, ShiftEnum> = {
  [ShiftEnum.Morning]: 'صبح',
  [ShiftEnum.Noon]: 'ظهر',
  [ShiftEnum.Night]: 'شب',
}
